import React from "react";
import { AlertCircle } from "tabler-icons-react";

/**
 * Composant d'état d'erreur
 */
const ErrorState = ({ onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center h-64 text-center px-4">
      <AlertCircle size={48} className="text-danger mb-4" />
      <h3 className="text-lg font-bold text-primary mb-2">
        Erreur de chargement
      </h3>
      <p className="text-primary/60 mb-4">
        Impossible de charger les informations de l'enfant.
      </p>
      <button
        onClick={onRetry}
        className="bg-primary text-white font-bold py-2 px-6 rounded-full hover:bg-primary/90 transition-colors"
      >
        Réessayer
      </button>
    </div>
  );
};

export default ErrorState;
